/* Hobbyteka product page: on desktop moves variant picker, quantity, price, buy buttons,
   wishlist and the painted/unpainted link into one buybox under the gallery. */
(function () {
  var savedPositions = [];
  var buyBox = null;
  var resizeTimer = null;

  // ---- Delivery estimate. The numbers are set in Theme settings > Production time and arrive via data attributes; the values below are only a fallback. ----
  var HB_DELIVERY = {
    printBusinessDays: [3, 10],   // printing, in business days (Mon-Fri)
    paintWeeks: [2, 8],           // hand painting, on top of printing (painted version only)
    transitDays: [7, 14],         // shipping after dispatch, calendar days
    noShipEU: ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE']
  };
  var HB_MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  function hbAddDays(d, n) { var x = new Date(d.getFullYear(), d.getMonth(), d.getDate()); x.setDate(x.getDate() + n); return x; }
  function hbAddBusinessDays(d, n) {
    var x = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; }
    return x;
  }
  function hbWeeks(r) {
    var a = Math.max(1, Math.round(r[0] / 7)), b = Math.max(a, Math.round(r[1] / 7));
    return (a === b ? a : a + '–' + b) + (b === 1 ? ' week' : ' weeks');
  }
  function hbFmt(d, withYear) { return HB_MONTHS[d.getMonth()] + ' ' + d.getDate() + (withYear ? ', ' + d.getFullYear() : ''); }

  function renderDelivery(info) {
    var el = info.querySelector('.hb-delivery');
    if (!el || el.getAttribute('data-ready')) return;
    el.setAttribute('data-ready', '1');
    var country = (el.getAttribute('data-country') || '').toUpperCase();
    if (HB_DELIVERY.noShipEU.indexOf(country) !== -1) {
      el.className += ' hb-delivery--noship';
      el.innerHTML = '<p class="hb-delivery__main"><strong>Unfortunately, as of today we can’t ship to your country.</strong></p><p class="hb-delivery__note">We really hope this changes soon.</p>';
      return;
    }
    var painted = el.getAttribute('data-version') === 'painted';
    function pair(attr, fallback) {
      var src = document.getElementById('hb-delivery-data') || el;
      var p = (src.getAttribute(attr) || '').split(',').map(Number);
      return (p.length === 2 && p[0] >= 0 && p[1] >= p[0]) ? p : fallback;
    }
    HB_DELIVERY.printBusinessDays = pair('data-print', HB_DELIVERY.printBusinessDays);
    HB_DELIVERY.paintWeeks = pair('data-paint', HB_DELIVERY.paintWeeks);
    HB_DELIVERY.transitDays = pair('data-transit', HB_DELIVERY.transitDays);
    var today = new Date();
    var from = hbAddBusinessDays(today, HB_DELIVERY.printBusinessDays[0]);
    var to = hbAddBusinessDays(today, HB_DELIVERY.printBusinessDays[1]);
    if (painted) { from = hbAddDays(from, HB_DELIVERY.paintWeeks[0] * 7); to = hbAddDays(to, HB_DELIVERY.paintWeeks[1] * 7); }
    from = hbAddDays(from, HB_DELIVERY.transitDays[0]);
    to = hbAddDays(to, HB_DELIVERY.transitDays[1]);
    var yearNow = today.getFullYear();
    var endYear = to.getFullYear() !== yearNow;
    var startYear = from.getFullYear() !== to.getFullYear();
    var mto = '<p class="hb-delivery__mto"><strong>Made to order.</strong> Printing takes ' + HB_DELIVERY.printBusinessDays[0] + '–' + HB_DELIVERY.printBusinessDays[1] + ' business days' +
      (painted ? ', hand painting adds ' + HB_DELIVERY.paintWeeks[0] + '–' + HB_DELIVERY.paintWeeks[1] + ' weeks' : '') + '.</p>';
    el.innerHTML = mto + '<p class="hb-delivery__main"><strong>Estimated delivery:</strong> ' + hbFmt(from, startYear) + ' – ' + hbFmt(to, endYear) + '</p>' +
      '<p class="hb-delivery__note">We stand behind the production time. Shipping usually takes ' + hbWeeks(HB_DELIVERY.transitDays) + ' after dispatch and depends on the carrier.</p>';
  }

  function initProductLayout() {
    var root = document.querySelector('[id^=MainProduct-]');
    if (!root) return false;
    var media = root.querySelector('.product__media-wrapper');
    var info = root.querySelector('.product__info-container');
    if (!media || !info) return false;

    var variantPicker = info.querySelector('variant-selects') || info.querySelector('variant-radios') || info.querySelector('.product-form__input');
    var quantityInput = info.querySelector('.product-form__quantity');
    var quantityBlock = quantityInput ? (quantityInput.closest('.product-form__input') || quantityInput) : null;
    var price = info.querySelector('[id^=price-]');
    var tax = info.querySelector('.product__tax');
    var installmentForm = info.querySelector('form.installment');
    var installmentBlock = installmentForm ? installmentForm.parentElement : null;
    var productForm = info.querySelector('product-form.product-form');
    var buyButtonsBlock = productForm ? productForm.parentElement : null;
    renderDelivery(info);
    var deliveryBlock = info.querySelector('.hb-delivery');
    if (document.getElementById('hb-delivery-data') && !deliveryBlock) return false;
    var wishlistBlock = info.querySelector('.shopify-app-block');
    var extrasBlock = info.querySelector('.hb-product-extras');

    var titleBlock = info.querySelector('.product__title') || document.querySelector('.hb-title-top');
    var titleMarker = null;
    if (titleBlock && !titleBlock.classList.contains('hb-title-top')) {
      titleMarker = document.createComment('hobbyteka-title-original-position');
      titleBlock.parentNode.insertBefore(titleMarker, titleBlock);
    }
    function placeTitle(mobile) {
      if (!titleBlock) return;
      if (mobile) {
        if (titleBlock.nextElementSibling !== media) media.parentNode.insertBefore(titleBlock, media);
        titleBlock.classList.add('hb-title-top');
      } else if (titleMarker && titleMarker.parentNode) {
        titleMarker.parentNode.insertBefore(titleBlock, titleMarker.nextSibling);
        titleBlock.classList.remove('hb-title-top');
      }
    }

    var elements = [variantPicker, quantityBlock, price, tax, deliveryBlock, installmentBlock, buyButtonsBlock, wishlistBlock, extrasBlock].filter(Boolean);
    var cleanElements = elements.filter(function (element, index, array) {
      return !array.some(function (other, otherIndex) {
        return otherIndex !== index && other.contains && other.contains(element);
      });
    });
    if (!cleanElements.length) return false;

    if (!buyBox) {
      buyBox = document.createElement('div');
      buyBox.className = 'hobbyteka-product-buybox';
    }

    cleanElements.forEach(function (element) {
      var alreadySaved = savedPositions.some(function (item) { return item.element === element; });
      if (alreadySaved) return;
      var marker = document.createComment('hobbyteka-product-original-position');
      element.parentNode.insertBefore(marker, element);
      savedPositions.push({ element: element, marker: marker });
    });

    function desktopLayout() {
      if (!buyBox.isConnected) media.appendChild(buyBox);
      savedPositions.forEach(function (item) {
        if (item.element && !buyBox.contains(item.element)) buyBox.appendChild(item.element);
      });
    }

    function mobileLayout() {
      savedPositions.forEach(function (item) {
        if (item.element && item.marker && item.marker.parentNode) {
          item.marker.parentNode.insertBefore(item.element, item.marker.nextSibling);
        }
      });
      if (buyBox.isConnected) buyBox.remove();
    }

    function applyLayout() {
      if (window.innerWidth >= 750) { desktopLayout(); placeTitle(false); } else { mobileLayout(); placeTitle(true); }
    }

    applyLayout();
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(applyLayout, 100);
    });
    return true;
  }

  function start() {
    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      if (initProductLayout() || attempts >= 30) clearInterval(timer);
    }, 150);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function () { savedPositions = []; buyBox = null; start(); });
})();
